import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BanksService } from '../../../../services/banks.service';
import { ToastService } from "../../../../services/toast.service";
import { LoadingService } from "../../../../services/loading.service";

interface BankForm {
  accountNumber: string;
  bankName: string;
  address: string;
  branch: string;
  phone: string;
  accountType: string;
}

@Component({
  selector: 'app-new-bank',
  templateUrl: './new-bank.component.html',
  styleUrls: ['./new-bank.component.scss']
})
export class NewBankComponent implements OnInit {
  bankForm!: FormGroup;
  isEditing = false;
  bankId: string | null = null;
  submitting = false;

  constructor(
    private fb: FormBuilder,
    private bankService: BanksService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.bankId = this.route.snapshot.paramMap.get('id');
    if (this.bankId) {
      this.isEditing = true;
      this.loadBank();
    }
  }

  private initForm(): void {
    this.bankForm = this.fb.group({
      bankName: ['', [Validators.required, Validators.minLength(3)]],
      accountNumber: ['', [Validators.required, Validators.minLength(5)]],
      accountType: ['', [Validators.required]],
      branch: [''],
      phone: ['', [Validators.pattern('^[0-9]{10}$')]],
      address: ['']
    });
  }

  private loadBank(): void {
    this.loadingService.show();
    this.bankService.getById(Number(this.bankId)).subscribe({
      next: (response) => {
        this.bankForm.patchValue(response.data);
        this.loadingService.hide();
      },
      error: () => {
        this.toastService.showToast('error', 'Error al cargar la información del banco');
        this.loadingService.hide();
        this.router.navigate(['/config/banks']);
      }
    });
  }

  onSubmit(): void {
    if (this.bankForm.invalid || this.submitting) {
      this.bankForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.loadingService.show();

    const bankData: BankForm = this.bankForm.value;
    const request = this.isEditing
      ? this.bankService.update(Number(this.bankId), bankData)
      : this.bankService.insert(bankData);

    request.subscribe({
      next: () => {
        this.toastService.showToast(
          'success',
          `Banco ${this.isEditing ? 'actualizado' : 'creado'} exitosamente`
        );
        this.router.navigate(['/config/banks']);
      },
      error: () => {
        this.toastService.showToast(
          'error',
          `Error al ${this.isEditing ? 'actualizar' : 'crear'} el banco`
        );
      },
      complete: () => {
        this.submitting = false;
        this.loadingService.hide();
      }
    });
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.bankForm.get(controlName);
    return control?.touched && control?.hasError(errorType) || false;
  }
}
